// extracted by mini-css-extract-plugin
module.exports = {"rightColumn":"style-module__rightColumn___3jAlF","select":"style-module__select___3H3F_"};